import { useSettings } from "@/context/SettingsContext";
import { X, Zap } from "lucide-react";
import { useState } from "react";

export default function PromoBanner() {
    const { t, settings } = useSettings();
    const [dismissed, setDismissed] = useState(false);

    const enabled = settings?.promo_enabled === "true";
    const text = settings?.promo_text || "";
    const subtext = settings?.promo_subtext || "";
    const bg = settings?.promo_bg || "#10B981";
    const textColor = settings?.promo_text_color || "#ffffff";

    if (!enabled || !text || dismissed) return null;

    return (
        <div
            className="relative w-full flex items-center justify-center gap-3 px-10 py-2.5 text-sm font-medium overflow-hidden"
            style={{ background: bg, color: textColor }}
        >
            {/* Animated shimmer */}
            <div style={{
                position: "absolute", inset: 0, opacity: 0.15,
                background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.6) 50%, transparent 100%)",
                animation: "shimmer 3s infinite",
            }} />
            <style>{`@keyframes shimmer { 0% { transform: translateX(-100%); } 100% { transform: translateX(100%); } }`}</style>

            {/* Icon */}
            <Zap size={15} style={{ color: textColor, opacity: 0.9, flexShrink: 0 }} />

            {/* Text */}
            <div className="flex items-center gap-2 flex-wrap justify-center">
                <span className="font-bold">{text}</span>
                {subtext && (
                    <span style={{ opacity: 0.8, fontSize: "0.8rem" }}>{subtext}</span>
                )}
            </div>

            {/* Dismiss */}
            <button
                onClick={() => setDismissed(true)}
                className="absolute right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 transition-opacity"
                aria-label="Dismiss"
                style={{ color: textColor }}
            >
                <X size={15} />
            </button>
        </div>
    );
}